import React, { useEffect, useState } from "react";
import {
  Drawer,
  FormControlLabel,
  FormGroup,
  IconButton,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { IoFilter } from "react-icons/io5";
import { LiaTrashAlt } from "react-icons/lia";
import dayjs from "dayjs";
import CustomTable from "../../../components/CustomTable";
import Pagination from "../../../components/Pagination";
import CustomModal from "../../../components/CustomModal";
import axios from "axios";
import { useTheme } from "../../../style/theme";
import { Button, Checkbox } from "@mui/material";
import { LuCalendarDays } from "react-icons/lu";
import { DeleteIcon, X } from "lucide-react";
import { RiDeleteBinLine } from "react-icons/ri";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
export default function AllTasks() {
  const [filterModal, setFilterModal] = useState(false);
  const [addTaskModal, setAddTaskModal] = useState(false);
  const [viewTaskModal, setViewTaskModal] = useState(false);
  const [editTaskModal, setEditTaskModal] = useState(false);
const [deleteModal,setDeleteModal] = useState()
  const [data, setData] = useState([]);
  const [option, setOption] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5,
  });
  const [totalRows, setTotalRows] = useState(0);
  const [sorting, setSorting] = useState([{ id: "id", desc: false }]);
  const [rowSelection, setRowSelection] = useState({});
  // const fetchData = async (pageIndex, pageSize, sorting) => {
  //   const response = await axios.get(`/hr/task`, {
  //     params: {
  //       page: pageIndex + 1,
  //       limit: pageSize,
  //     },
  //   });
  //   setData(response.data.result.docs);
  //   setTotalRows(response.data.result.totalPages);
  // };
  // useEffect(() => {
  //   fetchData(pagination.pageIndex, pagination.pageSize, sorting);
  // }, [pagination.pageIndex, pagination.pageSize, sorting]);
  // const columns = [
  //   { header: "Task Name", accessorKey: "name", enableSorting: false },
  //   {
  //     accessorKey: "task_owner",
  //     header: "Task Owner",
  //     enableSorting: false,
  //   },
  //   { header: "Assigned To", accessorKey: "assigned_to", enableSorting: false },
  //   { header: "Start Date", accessorKey: "startDate", enableSorting: false },
  //   { header: "End Date", accessorKey: "endDate", enableSorting: false },
  //   {
  //     accessorKey: "actions",
  //     header: "Actions",
  //     enableSorting: false,
  //   },
  // ];
  const renderRowSelection = (table) => {
    return (
      <div>
        {Object.keys(rowSelection).length > 0 && (
          <Button variant="contained" color="error" onClick={() => {}}>
            Delete
          </Button>
        )}
      </div>
    );
  };
  const handleRowClick = (row) => {
    // setViewRecordModal(true);
  };
  const renderActions = (row) => {
    console.log();
    return (
      <div className="flex flex-row items-center">
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={
                  row.original.statusId.name == "completed" ? true : false
                }
                onChange={() => {}}
              />
            }
          />
        </FormGroup>
        <IconButton
          onClick={() => {
            console.log("Delete Button Clicked");
          }}
        >
          <LiaTrashAlt />
        </IconButton>
      </div>
    );
  };

  const addTaskModalFields = [
    {
      type: "autocomplete",
      name: "taskOwner",
      label: "Task Owner",
      options: ["Task Owner 1", "Task Owner 2"],
      defaultValue: "",
    },
    {
      type: "text",
      label: "Task Name",
      name: "taskName",
      defaultValue: "",
    },
    {
      type: "textarea",
      label: "Description",
      name: "description",
      defaultValue: "",
    },
    {
      type: "datePicker",
      label: "Start Date",
      name: "startDate",
      defaultValue: dayjs("2023-10-01"),
    },
    {
      type: "datePicker",
      label: "Due Date",
      name: "dueDate",
      defaultValue: dayjs("2023-10-01"),
    },
    {
      type: "dateTimePicker",
      label: "Reminder",
      name: "reminder",
      defaultValue: dayjs("2023-10-01"),
    },
    {
      type: "select",
      name: "priority",
      label: "Priority",
      options: [
        { label: "Select", value: "select" },
        { label: "Low", value: "low" },
        { label: "Moderate", value: "moderate" },
        { label: "High", value: "high" },
      ],
      defaultValue: "select",
    },
    {
      type: "select",
      name: "status",
      label: "Status",
      options: [
        { label: "Select", value: "select" },
        { label: "Open", value: "open" },
        { label: "Completed", value: "completed" },
      ],
      defaultValue: "select",
    },
  ];
  const handleAddTaskFormSubmit = (data) => {
    console.log("Add Form :- ", data);
  };

  const viewTaskModalFields = [
    {
      type: "autocomplete",
      name: "taskOwner",
      label: "Task Owner",
      options: ["Task Owner 1", "Task Owner 2"],
      defaultValue: "Task Owner 1",
    },
    {
      type: "text",
      label: "Task Name",
      name: "taskName",
      defaultValue: "Name",
    },
    {
      type: "textarea",
      label: "Description",
      name: "description",
      defaultValue: "Description",
    },
    {
      type: "datePicker",
      label: "Start Date",
      name: "startDate",
      defaultValue: dayjs("2023-10-01"),
    },
    {
      type: "datePicker",
      label: "Due Date",
      name: "dueDate",
      defaultValue: dayjs("2023-10-01"),
    },
    {
      type: "dateTimePicker",
      label: "Reminder",
      name: "reminder",
      defaultValue: dayjs("2023-10-01"),
    },
    {
      type: "text",
      label: "Assigned To",
      name: "assignedTo",
      defaultValue: "Assigned To",
    },
    {
      type: "select",
      name: "priority",
      label: "Priority",
      options: [
        { label: "Select", value: "select" },
        { label: "Low", value: "low" },
        { label: "Moderate", value: "moderate" },
        { label: "High", value: "high" },
      ],
      defaultValue: "select",
    },
    {
      type: "select",
      name: "status",
      label: "Status",
      options: [
        { label: "Select", value: "select" },
        { label: "Open", value: "open" },
        { label: "Completed", value: "completed" },
      ],
      defaultValue: "select",
    },
    {
      type: "text",
      label: "Completed On",
      name: "completedOn",
      defaultValue: "",
    },
    {
      type: "text",
      label: "Completed By",
      name: "completedBy",
      defaultValue: "",
    },
  ];

  const editTaskModalFields = [
    {
      type: "autocomplete",
      name: "taskOwner",
      label: "Task Owner",
      options: ["Task Owner 1", "Task Owner 2"],
      defaultValue: "Task Owner 1",
    },
    {
      type: "text",
      label: "Task Name",
      name: "taskName",
      defaultValue: "Task Name",
    },
    {
      type: "textarea",
      label: "Description",
      name: "description",
      defaultValue: "Description",
    },
    {
      type: "datePicker",
      label: "Start Date",
      name: "startDate",
      defaultValue: dayjs("2023-10-01"),
    },
    {
      type: "datePicker",
      label: "Due Date",
      name: "dueDate",
      defaultValue: dayjs("2023-10-01"),
    },
    {
      type: "dateTimePicker",
      label: "Reminder",
      name: "reminder",
      defaultValue: dayjs("2023-10-01"),
    },
    {
      type: "text",
      label: "Assigned To",
      name: "assignedTo",
      defaultValue: "Assigned To",
      disabled: true,
    },
    {
      type: "select",
      name: "priority",
      label: "Priority",
      options: [
        { label: "Select", value: "select" },
        { label: "Low", value: "low" },
        { label: "Moderate", value: "moderate" },
        { label: "High", value: "high" },
      ],
      defaultValue: "select",
    },
    {
      type: "select",
      name: "status",
      label: "Status",
      options: [
        { label: "Select", value: "select" },
        { label: "Open", value: "open" },
        { label: "Completed", value: "completed" },
      ],
      defaultValue: "select",
    },
    {
      type: "text",
      label: "Completed On",
      name: "completedOn",
      defaultValue: "Completed On",
      disabled: true,
    },
    {
      type: "text",
      label: "Completed By",
      name: "completedBy",
      defaultValue: "Completed On",
      disabled: true,
    },
  ];
  const handleEditTaskFormSubmit = (data) => {
    console.log("Edit Form :- ", data);
  };

  const filterModalFields = [
    {
      type: "autocomplete",
      name: "priority",
      label: "Priority",
      options: ["Priority 1", "Priority 2"],
      defaultValue: "",
    },
    {
      type: "autocomplete",
      name: "relatedForms",
      label: "Related Forms",
      options: ["Related Forms 1", "Related Forms 2"],
      defaultValue: "",
    },
  ];
  const handleFilterFormSubmit = (data) => {
    console.log("Filter Form :- ", data);
  };

  const tasks = [
    {
      id: 1,
      title: "Test1",
      date: "21 Feb",
      assignee: "tanya gwilsbry",
      status: "Open",
      image_url: "/images/no-user.png",
    },
    {
      id: 2,
      title: "Test1",
      date: "21 Feb",
      assignee: "tanya gwilsbry",
      status: "Completed",
      image_url: "/images/no-user.png",
    },
  ];

  const totalCount = tasks.length;
  const openCount = tasks.filter((task) => task.status === "Open").length;
  const completedCount = tasks.filter((task) => task.status === "Completed").length

  const [filter, setFilter] = useState("Total");

  const filteredTasks = tasks.filter(
    (task) => filter === "Total" || task.status === filter
  );

  const { mode } = useTheme();

  const Periodoptions = [
    { value: "Moderate", label: "Moderate" },
    { value: "High", label: "High" },
    { value: "Low", label: "Low" },
    { value: "abc", label: "abc" },
  ];

  const relatedForms = [
    { value: "Address Proof", label: "Address Proof" },
    { value: "Bonafide Letter", label: "Bonafide Letter" },
    { value: "Compensatory Request", label: "Compensatory Request" },
    { value: "Department", label: "Department" },
    { value: "Designation", label: "Designation" },
  ];

  const taskowner = [
    { value: "Tanya Gwilsbry", label: "Tanya Gwilsbry" },
    { value: "Saad Khan", label: "Saad Khan" },
  ];

  const status = [
    { value: "Open", label: "Open" },
    { value: "Completed", label: "Completed" },
  ];
  return (
    <div className="w-full min-h-80 flex flex-col gap-3">
      <div className="container mx-auto p-4">
        <div className="flex items-center gap-2 justify-between mb-4">
          <div className="flex gap-2 items-center">
            <button
              className={`px-4 h-[29px] tex-[#000] rounded-md text-[14px] ${
                filter === "Total"
                  ? "bg-[#eff8ff] "
                  : "bg-[#fff] "
              }`}
              onClick={() => setFilter("Total")}
            >
              Total {totalCount}
            </button>
            <button
              className={`px-4 h-[29px] tex-[#000] rounded-md text-[14px] ${
                filter === "Open"
                  ? "bg-[#eff8ff] "
                  : "bg-[#fff] "
              }`}
              onClick={() => setFilter("Open")}
            >
              Open <span className='text-[#0088ff]'>{openCount}</span>
            </button>
            <button
              className={`px-4 h-[29px] tex-[#000] rounded-md text-[14px] ${
                filter === "Completed"
                  ? "bg-[#eff8ff] "
                  : "bg-[#fff] "
              }`}
              onClick={() => setFilter("Completed")}
            >
              Completed <span className='text-[#0EBC6B]'>{completedCount}</span>
            </button>
          </div>
          <div className="flex gap-3 items-center">
            <Button
              variant="contained"
              onClick={() => {
                setAddTaskModal(true);
              }}
              sx={{ height: "32px" }}
            >
              Add Task
            </Button>
            <IconButton
              onClick={() => {
                setFilterModal(true);
              }}
              title="Filter"
            >
              <IoFilter />
            </IconButton>
          </div>
        </div>

        <table className="min-w-full table-auto">
  <thead>
    <tr className={`${mode === "light" ? "bg-[#E5E5F0]" : "bg-transparent"}`}>
      <td
        className={`p-2 text-left text-[14px] ${
          mode === "light" ? "text-[#222222]" : "text-[#666666]"
        }`}
      >
        Task Details
      </td>
      <td className="p-2 text-left text-[14px] text-[#666666]">Status</td>
      <td className="p-2 text-left text-[14px] text-[#666666]">Assigned To</td>
      <td ></td> {/* New column heading */}
    </tr>
  </thead>
  <tbody>
    {filteredTasks.map((task) => (
      <tr
        key={task.id}
        className="border-t group" // Added `group` class for hover effect
      >
        <td className="p-2">
          <div className="flex items-center">
            <Checkbox
              checked={task.status === "Completed"}
              disabled
              sx={{
                "&.Mui-checked": {
                  color: "#1976d2", // Primary blue jab checked hoga
                },
              }}
            />
            <div className="flex gap-2 items-center">
              <div>
                <img
                  className="rounded-md w-[37px] h-[37px]"
                  src={task.image_url}
                  alt=""
                />
              </div>

              <div className="flex flex-col text-[14px]">
                <span>{task.title}</span>
                <span className="text-gray-500 ml-2">
                  1 - {task.assignee} - {task.date}
                </span>
              </div>
            </div>
          </div>
        </td>
        <td
          className={`p-2 text-[14px] ${
            task.status === "Open" ? "text-blue-500" : "text-green-500"
          }`}
        >
          {task.status}
        </td>
        <td className="p-2">
          <div>
            <img
              className="rounded-md w-[37px] h-[37px]"
              src={task.image_url}
              alt=""
            />
          </div>
        </td>
        <td className="p-2 relative">
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100">
            {/* Delete icon, which will appear when hovering over the row */}
            <RiDeleteBinLine  onClick={()=>setDeleteModal(true)} size={18} className="text-[#616161] cursor-pointer"/>
          </div>
        </td>
      </tr>
    ))}
  </tbody>
</table>

      </div>


      <Dialog
      open={deleteModal}
      onClose={()=>setDeleteModal(false)}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: { borderRadius: 12, padding: '16px', position: 'relative' },
      }}
    >
      {/* Close Button */}
      <IconButton
        onClick={()=>setDeleteModal(false)}
        style={{ position: 'absolute', top: 8, right: 8 }}
      >
        <CloseIcon />
      </IconButton>

      {/* Warning Icon */}
      <Box display="flex" justifyContent="center" mt={2}>
        <Box
          sx={{
            backgroundColor: '#F87171', // Red-400
            borderRadius: '50%',
            p: 1.5,
            display: 'flex',
          }}
        >
          <WarningAmberRoundedIcon sx={{ color: 'white', fontSize: 30 }} />
        </Box>
      </Box>

      {/* Title */}
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold', fontSize: '1.2rem', mt: 1 }}>
        Delete task?
      </DialogTitle>

      {/* Content */}
      <DialogContent>
        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
         
        >
          Task will be permanently deleted. This action cannot be reversed.
        </Typography>
      </DialogContent>

      {/* Actions */}
      <DialogActions sx={{ justifyContent: 'center', gap: 2, mb: 1 }}>
        <Button
          variant="contained"
          color="error"
          sx={{ px: 4 }}
        >
          Confirm
        </Button>
        <Button
          variant="outlined"
          onClick={()=>setDeleteModal(false)}
          sx={{ px: 4 }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>

      <CustomModal
        title="Add Task"
        fields={addTaskModalFields}
        open={addTaskModal}
        onClose={() => {
          setAddTaskModal(false);
        }}
        onSubmit={handleAddTaskFormSubmit}
        isScrollable={true}
        isCustomSubmitButtom={true}
        customSubmitButton={
          <div className="w-full flex flex-row justify-between items-center">
            <Button variant="contained" type="submit">
              Submit
            </Button>
            <Button variant="contained" type="submit">
              Submit And New
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setAddTaskModal(false);
              }}
            >
              Cancle
            </Button>
          </div>
        }
      />

      <CustomModal
        title="View Task"
        fields={viewTaskModalFields}
        open={viewTaskModal}
        onClose={() => {
          setViewTaskModal(false);
        }}
        isView={true}
        isEditButton={true}
        onEditButtonClick={() => {
          setViewTaskModal(false);
          setEditTaskModal(true);
        }}
        isScrollable={true}
      />
      <CustomModal
        title="Edit Task"
        fields={editTaskModalFields}
        open={editTaskModal}
        onClose={() => {
          setEditTaskModal(false);
        }}
        onSubmit={handleEditTaskFormSubmit}
        isScrollable={true}
      />

      <Drawer
        anchor="right"
        open={filterModal}
        onClose={() => setFilterModal(false)}
      >
        <div
          style={{
            backgroundColor: mode === "light" ? "#fff" : "background.view",
          }}
          className="w-72 p-4"
        >
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-semibold mb-4">Filter</h2>
            <button
              className="border-none outline-none"
              onClick={() => setFilterModal(false)}
            >
              <X size={20} />
            </button>
          </div>
          <div>
            <TextField
              placeholder="Task Name"
              size="small"
              className="w-full"
              sx={{
                "& .MuiInputBase-root": {
                  height: "38px",
                },
              }}
            />
          </div>

          <label className="block text-sm font-medium mb-2 text-[#666666] mt-2">
            Priority
          </label>
          <Select
            value={option} // Directly bind `filter`
            onChange={(e) => setOption(e.target.value)} // MUI ke liye `.target.value` use hota hai
            fullWidth
            sx={{
              backgroundColor: mode === "light" ? "#fff" : "transparent",
              height: "34px",
            }}
          >
            {Periodoptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>

          <label className="block text-sm font-medium mb-2 text-[#666666] mt-2">
            Related Forms
          </label>
          <Select
            value={option} // Directly bind `filter`
            onChange={(e) => setOption(e.target.value)} // MUI ke liye `.target.value` use hota hai
            fullWidth
            sx={{
              backgroundColor: mode === "light" ? "#fff" : "transparent",
              height: "34px",
            }}
          >
            {relatedForms.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>

          <label className="block text-sm font-medium mb-2 text-[#666666] mt-2">
            Task Owner
          </label>
          <Select
            value={option} // Directly bind `filter`
            onChange={(e) => setOption(e.target.value)} // MUI ke liye `.target.value` use hota hai
            fullWidth
            sx={{
              backgroundColor: mode === "light" ? "#fff" : "transparent",
              height: "34px",
            }}
          >
            {taskowner.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>

          <label className="block text-sm font-medium mb-2 text-[#666666] mt-2">
            Status
          </label>
          <Select
            value={option} // Directly bind `filter`
            onChange={(e) => setOption(e.target.value)} // MUI ke liye `.target.value` use hota hai
            fullWidth
            sx={{
              backgroundColor: mode === "light" ? "#fff" : "transparent",
              height: "34px",
            }}
          >
            {status.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </div>
        <div className="flex items-end h-full mb-5 justify-start px-5 space-x-2">
          <Button variant="contained" sx={{ bgColor: "#0088ff" }}>
            Apply
          </Button>
          <Button variant="outlined" onClick={() => setOption("")}>
            Reset
          </Button>
        </div>
      </Drawer>
    </div>
  );
}
